<template>
  <div>
    <el-dialog
      :visible.sync="showDialog"
      :before-close="handleClose"
      :modal="false"
      width="450px"
    >
      <div
        class="dialog"
        @mouseenter="isLeaveDialog = false"
        @mouseleave="isLeaveDialog = true"
      >
        <div class="title" v-if="title">{{ title }}</div>
        <div class="title" v-else>
          <i class="el-icon-service"></i>
          <em>&nbsp;填写您的联系方式，我们会主动与您联系</em>
        </div>
        <ul class="dialogForm">
          <li :class="{ active: focusIdx == 1 }">
            <el-input
              v-model="form.name"
              clearable
              placeholder="联系人*"
              @blur="focusIdx = 0"
              @focus="focusIdx = 1"
            ></el-input>
          </li>
          <li :class="{ active: focusIdx == 2 }">
            <el-input
              v-model="form.tel"
              clearable
              placeholder="手机号*"
              @blur="focusIdx = 0"
              @focus="focusIdx = 2"
            ></el-input>
          </li>
          <li :class="{ active: focusIdx == 3 }">
            <el-input
              v-model="form.company"
              clearable
              placeholder="公司名称"
              @blur="focusIdx = 0"
              @focus="focusIdx = 3"
            ></el-input>
          </li>
          <li :class="{ active: focusIdx == 4 }">
            <el-input
              v-model="form.dir"
              clearable
              placeholder="合作方向"
              @blur="focusIdx = 0"
              @focus="focusIdx = 4"
            ></el-input>
          </li>
          <li :class="{ active: focusIdx == 5 }">
            <el-input
              v-model="form.mail"
              clearable
              placeholder="电子邮箱"
              @blur="focusIdx = 0"
              @focus="focusIdx = 5"
            ></el-input>
          </li>
          <li class="mar20_t">
            <el-button type="primary" class="w100_per" @click="onSubmit">
              提交
            </el-button>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {validatePhone,validateEMail,validate20Chart} from '@/utils/utils'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    systemId: {
      type: String,
      default: '1',
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
      focusIdx: 0,
      isLeaveDialog: false,
      form: {
        name: '',
        tel: '',
        company: '',
        dir: '',
        mail: '',
      },
    }
  },

  created() {},

  methods: {
    handleClose() {
      this.$emit('close')
    },

    onSubmit() {
      if (! validate20Chart(this.form.name)) {
        this.$message.warning('请填写正确的联系人姓名')
        return
      }
      if (! validatePhone(this.form.tel)) {
        this.$message.warning('请填写正确的联系人手机号')
        return
      }
      if(this.form.company.length > 30) {
        this.$message.warning("公司名称太长");
        return
      }
      if(! validateEMail(this.form.mail)) {
        this.$message.warning("请填写正确的联系邮箱");
        return
      }
      let strTemp =
        this.form.name +
        '_' +
        this.form.tel +
        '_' +
        this.form.company +
        '_' +
        this.form.mail
      this.$store
        .dispatch('api/informationsAdd', {
          informations: strTemp,
          system_id: this.systemId || '1',
        })
        .then((response) => {
          if (response.code == 0) {
            this.$message.success('提交成功')
            this.handleClose()
          }
        })
    },
  },
}
</script>

<style lang="scss">
.dialog {
  padding: 20px 40px;
  font-size: 16px;
  .close {
    position: absolute;
    right: 0px;
    top: 0px;
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    font-size: 18px;
  }
  .title {
    line-height: 35px;
    color: #414141;
  }

  ul.dialogForm {
    padding-top: 10px;
    li {
      border-bottom: 1px solid #ececec;
      margin-bottom: 10px;
    }
    li.active {
      border-color: #0087ff;
    }
  }

  .el-input__inner {
    border-color: #fff;
    border-radius: 0;
  }
}
</style>
